module.exports = "/_next/static/images/percentage-duotone-57ed9ed9a057e4ac4714081fd7a31540.svg";